import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_USERS = restRequest(
    "VRCORE.USER_MANAGER_TABLE_DATA_WIDGET.GET_USERS"
);
export const SET_PAGE = "VRCORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_PAGE";
export const SET_ROWS = "VRCORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_ROWS";
export const REMOVE_USER = restRequest(
    "VRCORE.USER_MANAGER_TABLE_DATA_WIDGET.REMOVE_USER"
);
export const SET_TABLE_CONFIG =
    "VRCORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_TABLE_CONFIG";
